import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { Provider as AlertProvider } from 'react-alert'
import { AlertTemplate } from '@touche-lts/panel-ui/dist'
import './index.css'

import 'moment'
import 'moment-duration-format'

class Root extends Component {
  render () {
    return (
      <AlertProvider
        template={AlertTemplate}
        position='bottom left'
        timeout={5000}
        offset='30px'
        transition='fade'
      >
        <App />
      </AlertProvider>
    )
  }
}

ReactDOM.render(<Root />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
